/**
 * Como um registro aparece numa lista de escolha.
 *
 * **Por que isto é um arquivo, e não uma linha repetida em cada tela.** Na
 * reunião de 30/10 a coordenação contou de duas professoras com o mesmo
 * primeiro nome e a aula atribuída à errada (`PESQUISA-ESPM.md` §23, item
 * 26). Num seletor, dois homônimos exatos aparecem como duas linhas
 * idênticas — e escolher entre elas é sorte. A regra daqui: **rótulo que
 * colide ganha a matrícula**, e só ele. Os outros 310 nomes continuam limpos.
 *
 * Fica fora de `.tsx` para o Node conseguir testar sem JSX.
 */

export type Registro = Record<string, unknown>

/** O nome que a pessoa reconhece: nome, rótulo, abreviatura — nessa ordem. */
export function rotuloDe(l: Registro): string {
  return String(l.nome ?? l.rotulo ?? l.abreviatura ?? l.id ?? '').trim() || String(l.id ?? '')
}

const chave = (s: string) =>
  s.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim().toUpperCase()

/**
 * O rótulo de cada registro, garantindo que dois registros nunca apareçam
 * iguais. Homônimo com matrícula ganha `· mat. 1001`; sem matrícula, ganha o
 * começo do id — feio, e é de propósito: é o sinal de que falta matrícula
 * justamente onde ela mais faz falta.
 */
export function rotulosDistintos(linhas: readonly Registro[]): Map<string, string> {
  const porChave = new Map<string, number>()
  for (const l of linhas) {
    const k = chave(rotuloDe(l))
    porChave.set(k, (porChave.get(k) ?? 0) + 1)
  }
  const out = new Map<string, string>()
  for (const l of linhas) {
    const base = rotuloDe(l)
    const id = String(l.id ?? '')
    if ((porChave.get(chave(base)) ?? 0) < 2) {
      out.set(id, base)
      continue
    }
    const matricula = l.codigo_externo ? String(l.codigo_externo).trim() : ''
    out.set(id, matricula ? `${base} · mat. ${matricula}` : `${base} · sem matrícula (${id.slice(0, 8)})`)
  }
  return out
}
